export default function Toggle({ checked, onChange, disabled = false, label }) {
  return (
    <label className="flex items-center gap-3 cursor-pointer select-none">
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={(e) => !disabled && onChange(e.target.checked)}
          disabled={disabled}
        />
        {/* Track */}
        <div
          className={`w-11 h-6 rounded-full transition-all duration-200 ${
            checked
              ? 'bg-accent shadow-glow'
              : 'bg-surface2 border border-surface2'
          } ${disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
        />
        {/* Knob */}
        <div
          className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full transition-transform duration-200 ${
            checked ? 'bg-bg translate-x-5' : 'bg-brand-muted translate-x-0'
          }`}
        />
      </div>
      {label && (
        <span className="text-sm text-brand-text">{label}</span>
      )}
    </label>
  )
}
